import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../../Utility/constants";
import { getSchoolId } from '../../../Utility/commonFunctions';
import ReportCardTemplate from './ReportCardTemplate';

const ReportCardPrint = () => {

    const { studentId, examType, sessionId } = useParams();

    const [studentData, setStudentData] = useState([]);
    const [marksData, setMarksData] = useState([]);
    const [schoolData, setSchoolData] = useState([]);

    useEffect(() => {

        const fetchData = async () => {

            try {

                const response = await axios.get(
                    `${baseUrl}/api/MarksFeeding/ReturnStudentDetailswithReportCardDetails?studentId=${studentId}&examType=${examType}&sessionId=${sessionId}`
                );

                if (response?.data) {

                    setStudentData(response.data.studentDetails);
                    setMarksData(response.data.marksFeedings);

                    if (response.data.studentDetails?.firstName) {

                        document.title =
                            `${response.data.studentDetails.firstName}_${response.data.studentDetails.lastName}_ReportCard`;
                    }
                }

                const schoolId = await getSchoolId();

                const schoolResponse = await axios.get(
                    `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
                );

                setSchoolData(schoolResponse.data);

            } catch (error) {
                console.log(error);
            }
        }

        fetchData();

    }, []);

    return (
        <ReportCardTemplate
            studentData={studentData}
            marksData={marksData}
            schoolData={schoolData}
        />
    )
}

export default ReportCardPrint;